export default __webpack_public_path__ + "img_220720_MHW_main_h_fullcolor_rgb.svg";